import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable, Subscription } from 'rxjs';
import { MccService } from 'src/app/mcc.service';
import { DlrService } from '../dlr.service';
import { startWith, map } from 'rxjs/operators';
import { ColumnsOrdersService } from 'src/app/common/columns-orders.service';
import moment                                                    from 'moment';
import copy                                                      from 'copy-to-clipboard';
import * as Excel from 'exceljs/dist/exceljs.min.js';
import { SelectedCell } from 'src/app/common/selected-cell';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ResizeEvent                                           } from 'angular-resizable-element';
import { SnackBarComponent } from 'src/app/snack-bar/snack-bar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { saveAs                              } from 'file-saver';

@Component({
  selector: 'app-dlr-summary',
  templateUrl: './dlr-summary.component.html',
  styleUrls: ['./dlr-summary.component.scss']
})
export class DlrSummaryComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() tabCode: string;
  @ViewChild('canvas', { static: true }) canvas: ElementRef<HTMLCanvasElement>;
  @ViewChild('target') targetElement: any;
  @ViewChild('sortDLRSummary', { static: true}) sortDLRSummary: MatSort;
  @ViewChild('dlrSummaryPaginator', { static: true}) dlrSummaryPaginator: MatPaginator;
  @ViewChild('tableElem', { static: true }) tableElem;

  dataSourceDLRSummary = new MatTableDataSource();

  clients: any[] = [];
  countries: any[] = [];

  displayedColumnsDLRSummary: string[] = [];
  columns: any[] = [];
  columnWidths: any = {};

  selectedCount = 0;

  statusValues  = [
    {text: 'All', value: null },
    {text: 'DELIVERED', value: 0},
    {text: 'UNDELIVERED',  value: 1}/* ,
    {text: 'PENDING',  value: 2} */
  ];

  filteredClients: Observable<any[]>;
  filteredCountries: Observable<any[]>;

  loadingData: number;

  emptyData: boolean;
  spinnerRef: MatDialogRef<any>;

  filterForm: FormGroup;

  /** FormControl for Client Account  */
  fcClientAccount = new FormControl(null);
  /** FormControl for Status  */
  /* fcStatus = new FormControl(null); */
  /** FormControl for MCC  */
  fcMCC = new FormControl(null);
  fcDateFrom = new FormControl(moment.utc().format('YYYY-MM-DD')/* , {updateOn: 'blur'} */);
/** FormControl for TimeFrom  */
  fcTimeFrom = new FormControl('00:00'/* , {updateOn: 'blur'} */);
  /** FormControl for DateTo  */
  fcDateTo = new FormControl(moment.utc().format('YYYY-MM-DD')/* , {updateOn: 'blur'} */);
  /** FormControl for TimeTo  */
  fcTimeTo = new FormControl('23:59'/* , {updateOn: 'blur'} */);

  dialogRef: MatDialogRef<any>;

  filterSubscriptions:   Subscription[] = [];

  pageName = 'DLR Response Summary';

  dlrResults = {
    deliv: 0,
    undeliv: 0,
    pend: 0
  };

  basicConf: Subscription;
  initialized = false;

  position: any;
  sortState: any;

  chromeTabs = true;

  tempTimeout;

  mouseDown = false;
  selX: number;
  selY: number;
  drawingSquare = 0;

  selectedCellsData: SelectedCell[] = [];
  startSelectionParams: SelectedCell = null;

  private ctx: CanvasRenderingContext2D;

  constructor(filForm: FormBuilder, private dlrService: DlrService, private mccService: MccService,
    private cdr: ChangeDetectorRef, private columnsOrderService: ColumnsOrdersService,
    private snackBar: MatSnackBar, private dialog: MatDialog) {

    if (this.chromeTabs) {
      this.tabCode = this.pageName;
    }

    this.filterForm = filForm.group({
      fcClientAccount: this.fcClientAccount,
      fcMCC: this.fcMCC,
      /* fcStatus: this.fcStatus, */
      fcDateFrom      : this.fcDateFrom,
      fcTimeFrom      : this.fcTimeFrom,
      fcDateTo        : this.fcDateTo,
      fcTimeTo        : this.fcTimeTo
    });

    this.setCommonSubscriptions();
    this.setFilterSubscriptions();
  }

  async initColumns(basicConf?) {

      this.columns = this.columnsOrderService.getColumnsOrder(this.tabCode);

      if (this.columns && this.columns.length) {
        this.displayedColumnsDLRSummary = this.columns
        .filter(it => it.visible === true)
        .map(it => it.name);
      } else {
        if (basicConf) {
          this.displayedColumnsDLRSummary = basicConf.columns
            .filter(it => it.visible === true)
            .map(it => it.name);
          this.columns = basicConf.columns;
          this.columnsOrderService.createConf(this.tabCode, basicConf.columns);
        }
      }
      this.columns.forEach(col => {
        this.columnWidths[col.name] = col.width + 'px';
      });
      this.cdr.detectChanges();

  }

  async setFilterSubscriptions() {
    this.filteredClients = this.fcClientAccount.valueChanges
    .pipe(
      startWith(''),
      map(value => this._filterClients(value))
    );

    this.filteredCountries = this.fcMCC.valueChanges
    .pipe(
      startWith(''),
      map(value => this._filter(value))
    );
  }

  setCommonSubscriptions() {
    this.filterSubscriptions.push(this.mccService.getCountries().subscribe(res => {
      this.countries = res;
    }));
  }

  calcDeliveryTime(element) {

    // 2020-01-17 11:59:58 pm
    // 2020-01-18 12:00:02 am
    const dateA  = moment.utc(element.create_timestamp, 'YYYY-MM-DD h:mm:ss A');
    const dateB  = moment.utc(element.update_timestamp, 'YYYY-MM-DD h:mm:ss A');
/*     const dateA  = moment('2020-01-17 11:59:58 PM', 'YYYY-MM-DD h:mm:ss A');
    const dateB  = moment('2020-01-18 12:00:02 AM', 'YYYY-MM-DD h:mm:ss A'); */
    const d      = moment.duration(dateA.diff(dateB));

    const h = d.get('hours')   < 0 ? Math.abs(d.get('hours'))   : d.get('hours');
    const m = d.get('minutes') < 0 ? Math.abs(d.get('minutes')) : d.get('minutes');
    const s = d.get('seconds') < 0 ? Math.abs(d.get('seconds')) : d.get('seconds');

    const dlvrd = {
      h: h < 10 ? '0' + h : h,
      m: m < 10 ? '0' + m : m,
      s: s < 10 ? '0' + s : s,
      date: ''
    };

    dlvrd.date = dlvrd.h + ':' + dlvrd.m + ':' + dlvrd.s;

    const deliveryTime = element.status != null ? dlvrd.date : '';
    return deliveryTime;

  }

  ngOnInit(): void {
    this.ctx = this.canvas.nativeElement.getContext('2d');
    this.ctx.canvas.width = 0;
    this.ctx.canvas.height = 0;
    this.loadingData = 0;

    if (this.chromeTabs) {
      this.tabCode = this.pageName;
    }

    this.columnsOrderService.createBasicConfObservable(this.pageName);
    this.basicConf = this.columnsOrderService.getBasicColumnsConfig().subscribe(conf => {
      this.initColumns(conf);
    });
    this.basicConf.unsubscribe();
  }

  ngAfterViewInit() {
    this.dataSourceDLRSummary.sort = this.sortDLRSummary;
    this.dataSourceDLRSummary.paginator = this.dlrSummaryPaginator;
    this.initialized = true;
  }

  refreshData() {
    this.emptyData = false;
    this.dlrResults = {
      deliv: 0,
      undeliv: 0,
      pend: 0
    };
    this.setSubscription();
  }

  findMCC(country) {
    const found = this.countries.find(item => (item.mcc + ' - ' + item.country) === country);
    return found ? found.mcc : null;
  }

  findClientId(client) {
    const found = this.clients.find(cli => (client.name + ' - ' + client.id) === client);
    return found ? found.id : null;
  }

  getUtcTime(date, time: string, par: number) {
    const dt = moment(date).format('YYYY-MM-DD') + ' ' + time;
    if (par === 0) {
      return moment.utc(dt).format('YYYY-MM-DD HH:mm:ss');
    }
    if (par === 1) {
      return moment.utc(dt).add(59, 'seconds').format('YYYY-MM-DD HH:mm:ss');
    }
    if (par === 2) {
      return moment.utc(dt).format();
    }
    if (par === 3) {
      return moment.utc(dt).add(59, 'seconds').format();
    }

    return 0;
  }

  setSubscription() {

    this.loadingData = 1;

    const model = {
      client_id: this.fcClientAccount.value ? this.findClientId(this.fcClientAccount.value) : null,
      mcc: this.fcMCC.value ? this.findMCC(this.fcMCC.value) : null,
      date_from: this.getUtcTime(this.fcDateFrom.value, this.fcTimeFrom.value, 0),
      date_to: this.getUtcTime(this.fcDateTo.value, this.fcTimeTo.value, 1)
    };

    this.dlrService.getDlrSummary(model).toPromise().then(res => {
      if (res.body) {
        const ar = res.body;
        const cliv = this.fcClientAccount.value ? this.fcClientAccount.value : 'ALL';
        const mccv = this.fcMCC.value ? this.fcMCC.value : 'ALL';
        ar.forEach(element => {
          element.time = moment.utc(element.delay*1000).format('mm:ss');
          element.account = cliv;
          element.mcc = mccv;
          this.dlrResults.deliv = this.dlrResults.deliv + element.delivered;
          this.dlrResults.undeliv = this.dlrResults.undeliv + element.undelivered;

          const sum = element.delivered + element.undelivered;
          element.del_percent = 100 * element.delivered / sum;
          element.undel_percent = 100 *  element.undelivered / sum;
        });
        this.dataSourceDLRSummary.data = ar;
        this.emptyData = ar.length === 0 ? true : false;
      } else {
        this.dataSourceDLRSummary.data = [];
        this.emptyData = true;
      }

      this.loadingData = 2;
    }).catch(err => {
      this.openSnackBar(['-' + 'Error retrieving DLR summary data']);
      this.loadingData = 2;
    });

  }

  async downloadExcel() {

    const { LoadingSpinnerComponent } = await import(
      'src/app/dialogs/loading-spinner/loading-spinner.component'
    );

    this.spinnerRef = this.dialog.open(LoadingSpinnerComponent, {
      width: '300px',
      disableClose: true,
      hasBackdrop: true,
      id: 'spinner' + this.tabCode,

    });

    const workbook = new Excel.Workbook();

    const worksheet = workbook.addWorksheet('Data');

    const headers = [];

    const colDefs = [];

    const exportCols = this.displayedColumnsDLRSummary;
    exportCols.forEach(header => {
      const ind = this.columns.findIndex(dc => dc.name === header);

      if (ind > -1) {
        headers.push(this.columns[ind].displayedName);
        if (['Account', 'MCC (Country)'].indexOf(this.columns[ind].displayedName) > -1) {
          colDefs.push({key: this.columns[ind].name, width: 35});
        } else {
          colDefs.push({key: this.columns[ind].name, width: 17});
        }
      }

    });

    worksheet.columns = colDefs;

    const dataT = [];

    const rowH = worksheet.addRow(headers);
    rowH.eachCell(cell => {
      dataT.push('');
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
          fgColor: { argb: 'eeeeee'}
      };
      cell.alignment = {horizontal: 'center' };
    });

    this.dataSourceDLRSummary.data.forEach((item: any) => {
      const dataR = [];
      colDefs.forEach(col => {
        dataR.push(item[col.key]);
      });
      const row = worksheet.addRow(dataR);
    });

    dataT[0] = 'Totals';

    dataT[dataT.length - 4] = this.dlrResults.deliv;
    dataT[dataT.length - 3] = this.dlrResults.undeliv;
    dataT[dataT.length - 2] = (this.dlrResults.deliv / (this.dlrResults.deliv + this.dlrResults.undeliv) * 100).toPrecision(6);
    dataT[dataT.length - 1] = (this.dlrResults.undeliv / (this.dlrResults.deliv + this.dlrResults.undeliv) * 100).toPrecision(6) ;
    const rowT = worksheet.addRow(dataT);
    rowT.eachCell(cell => {
      cell.font = {
        bold: true
      };
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
          fgColor: { argb: 'eeeeee'}
      };
    });

    workbook.xlsx.writeBuffer()
    .then(buffer => {
      saveAs(new Blob([buffer]), 'dlr_summary_' + moment().format('YYYYMMDDTHHmm') + '.xlsx');
      this.spinnerRef.close();
      this.openSnackBar(['+' + 'Exported table was successfully saved to your browser\'s download folder']);
    })
    .catch(err => {
      this.spinnerRef.close();
      this.openSnackBar(['-Error writing excel export: ' + err]);
    });

  }

  async generateAsGraph() {
    const { ViewDlrSummaryChartComponent } = await import(
      /* webpackPrefetch: true */
      './view-dlr-summary-chart/view-dlr-summary-chart.component'
      );

      this.dialogRef = this.dialog.open(ViewDlrSummaryChartComponent, {
        width         : '1100px',
        disableClose  : false,
        hasBackdrop   : false,
        id            : 'viewDlrSummaryChart' + this.tabCode,
        data          : {
          tab     : this.tabCode,
          data : this.dataSourceDLRSummary.data,
          period: this.getUtcTime(this.fcDateFrom.value, this.fcTimeFrom.value, 0) + ' to ' +
          this.getUtcTime(this.fcDateTo.value, this.fcTimeTo.value, 1)
        }
      });
  }

  openSnackBar(message: Array<string>) {
    this.snackBar.openFromComponent(SnackBarComponent, {
      data: message
    });
  }

  resetFilter() {
    this.filterForm.reset();
    this.fcClientAccount.patchValue(null);
    /* this.fcStatus.patchValue(null); */
    this.fcMCC.patchValue(null);

    this.fcDateFrom.patchValue(moment.utc().format('YYYY-MM-DD'));
    this.fcDateTo.patchValue(moment.utc().format('YYYY-MM-DD'));
    this.fcTimeFrom.patchValue('00:00');
    this.fcTimeTo.patchValue('23:59');
  }

  setToday(dateControl: FormControl) {
    dateControl.patchValue(moment.utc().format('YYYY-MM-DD'));
  }


  scrolling(e) {
    window.clearTimeout( this.tempTimeout );
    // Set a timeout to run after scrolling ends
    this.tempTimeout = setTimeout(() => {
      this.position = {
        left: this.tableElem.nativeElement.scrollLeft,
        top: this.tableElem.nativeElement.scrollTop
      };
    }, 150);
  }

  sortChange(e) {
    this.sortState = {
      direction: this.sortDLRSummary.direction,
      active: this.sortDLRSummary.active
    };
  }

  drawing(param, event) {
    if (param) {
      this.mouseDown = param;

      this.ctx.canvas.width = this.targetElement.nativeElement.offsetWidth;//window.innerWidth/* table.clientWidth*/;
      this.ctx.canvas.height = window.innerHeight - 130 - 70 - 48 - 12 ;//window.innerHeight/*  table.clientHeight */;

      this.ctx.fillStyle = 'rgba(46, 114, 176, 0.3)';

      this.selX = event.layerX;
      this.selY = event.layerY;
    } else {
      if (this.drawingSquare > 25) {
        this.mouseDown = param;
      }
      this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
      this.ctx.canvas.width = 0;
      this.ctx.canvas.height = 0;
    }
  }

  mouseMoveTable(event) {
    if (this.mouseDown === true) {
      this.mouseDown = false;
    }
  }

  mouseMove(event) {
    if (this.mouseDown === true) {
      //this.ngZone.runOutsideAngular(() =>

      const x = event.layerX;//clientX - this.tableElem.nativeElement.offsetLeft + this.tableElem.nativeElement.scrollLeft;
      const y = event.layerY;//clientY - this.tableElem.nativeElement.offsetTop + this.tableElem.nativeElement.scrollTop - 40;

      this.drawSelection(x, y);
      //);
    }
  }

  drawSelection(w: number, h: number) {
    this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
    this.ctx.fillRect(this.selX, this.selY, w - this.selX , h - this.selY);
    this.drawingSquare = Math.abs((w - this.selX) * (h - this.selY));
  }

  getColWidth(name) {
    const found = this.columns.find(col => col.name === name);
    return found ? found.width + 'px' : 0 + 'px';
  }

  setColWidth(name, width) {
    const found = this.columns.find(col => col.name === name);
    if (found) {
      this.columnsOrderService.setColWidth(this.tabCode, name, width);
    }
  }

  onResizeEnd(event: ResizeEvent, columnName): void {
    if (event.edges.right) {
      const cssValue = event.rectangle.width;
      const columnElts: any = document.getElementsByClassName('mat-column-' + columnName);
      let flag = 0;
      for (const colEl of columnElts) {
        const currentEl = colEl as HTMLDivElement;
        currentEl.style.width = cssValue  + 'px';
        if (flag === 0) {
          this.setColWidth(columnName, cssValue);
          flag = flag + 1;
        }
      }
    }
  }

  checkIfCellSelected(colName, index) {
    // console.count(colName + index);
    const found = this.selectedCellsData.findIndex(cell => cell.colName === colName && cell.rowIndex === index);

    if (this.startSelectionParams && this.startSelectionParams.colName === colName && this.startSelectionParams.rowIndex === index) {
      return 0;
    }

    return found;
  }

  selectCellStart(colName: string, cell: any, event: MouseEvent, index) {
    // event.preventDefault();
    if (event.button === 0 && event.shiftKey === false && event.ctrlKey === false) {
      // this.mouseDown = true;

      this.selectedCellsData = [];
      this.startSelectionParams = {
        rowIndex: index,
        colName,
        data: cell[colName]
      };

      this.drawing(true, event);
    }
    // console.log('start', event.button === 0 && event.shiftKey === false && event.ctrlKey === false);
  }

  afterDrawing(colName: string, cell: any, event: MouseEvent, indexEnd) {
    if (this.mouseDown === false && this.drawingSquare > 25) {
      this.selectCellEnd(colName, cell, event, indexEnd);
    }
  }

  afterDrawingCell(colName: string, cell: any) {
    if (this.mouseDown === true && this.drawingSquare <= 25) {
      this.mouseDown = false;
      switch (colName) {
/*         case 'name': {
          this.showEditTradingRule(cell, 'edit');
          break;
        }
        case 'id': {
          this.showEditRoutingRule(cell.id);
          break;
        } */
        default:
          break;
      }
    }
  }

  selectCellEnd(colName: string, cell: any, event: MouseEvent, indexEnd) {
    event.preventDefault();
    if (/* this.mouseDown === true && */this.drawingSquare > 25 && this.startSelectionParams !== null && event.button === 0) {

      if ((this.startSelectionParams.rowIndex !== indexEnd || this.startSelectionParams.colName !== colName) ) {

        const startInd = this.startSelectionParams.rowIndex < indexEnd ? this.startSelectionParams.rowIndex : indexEnd;
        const endInd = this.startSelectionParams.rowIndex < indexEnd ? indexEnd : this.startSelectionParams.rowIndex;

        for (let index = startInd; index <= endInd; index++) {
          const element: any = this.dataSourceDLRSummary.connect().value[index];
          element.selected = true;

          const sti = this.displayedColumnsDLRSummary.findIndex(col => col === this.startSelectionParams.colName);
          const eti = this.displayedColumnsDLRSummary.findIndex(col => col === colName);
          const startColIndex = sti < eti ? sti : eti;
          const endColIndex = sti < eti ? eti : sti;

          for (let colIndex = startColIndex; colIndex <= endColIndex; colIndex++) {
            this.selectedCellsData.push({
              rowIndex: index,
              colName: this.displayedColumnsDLRSummary[colIndex],
              data: element[this.displayedColumnsDLRSummary[colIndex]]
            });
          }
        }
      }

    } else {
      if (event.shiftKey === true && this.startSelectionParams === null && event.button === 0) {

        this.selectedCellsData = [];
        this.startSelectionParams = {
          rowIndex: indexEnd,
          colName,
          data: cell[colName]
        };
      } else {
        if (event.ctrlKey === true  && event.button === 0) {
          cell.selected = true;
          const findIndex = this.checkIfCellSelected(colName, indexEnd);
          if (findIndex === -1) {
            this.selectedCellsData.push({
              rowIndex: indexEnd,
              colName,
              data: cell[colName]
            });
          } else {
            this.selectedCellsData.splice(findIndex, 1);
          }

        }

        if (event.shiftKey === true  && event.button === 0) {
          if (this.startSelectionParams) {

            const startInd = this.startSelectionParams.rowIndex < indexEnd ? this.startSelectionParams.rowIndex : indexEnd;
            const endInd = this.startSelectionParams.rowIndex < indexEnd ? indexEnd : this.startSelectionParams.rowIndex;

            for (let index = startInd; index <= endInd; index++) {
              const element: any = this.dataSourceDLRSummary.connect().value[index];
              element.selected = true;

              const sti = this.displayedColumnsDLRSummary.findIndex(col => col === this.startSelectionParams.colName);
              const eti = this.displayedColumnsDLRSummary.findIndex(col => col === colName);
              const startColIndex = sti < eti ? sti : eti;
              const endColIndex = sti < eti ? eti : sti;

              for (let colIndex = startColIndex; colIndex <= endColIndex; colIndex++) {
                this.selectedCellsData.push({
                  rowIndex: index,
                  colName: this.displayedColumnsDLRSummary[colIndex],
                  data: element[this.displayedColumnsDLRSummary[colIndex]]
                });
              }
            }
          }
        }

        if (event.shiftKey === false && event.ctrlKey === false && event.button === 0) {
          this.selectedCellsData = [];
        }
      }
    }

    this.mouseDown = false;
    this.drawingSquare = 0;


  }

  handleCopy(event) {
    event.preventDefault();
    this.copyToClipboard();
  }

  copyToClipboard() {
    const str = this.selectedCellsData.length ?
      this.selectedCellsData.map(item => item.data).join(', ') : this.startSelectionParams.data;
    copy(str);
  }


  ngOnDestroy() {
    this.filterSubscriptions.forEach(subsc => {
      subsc.unsubscribe();
    });
  }

  private _filter(value: string): any[] {
    if (value) {
      const filterValue = value.toLowerCase();
      const arr =  this.countries.filter(country => country.country.toLowerCase().includes(filterValue)
      || country.mcc.toString().includes(filterValue));

      return arr;
    } else {
      return this.countries;
    }
  }

  private _filterClients(value: string): any[] {
    if (value) {
      const filterValue = value.toLowerCase();
      const arr =  this.clients.filter(cli => cli.name.toLowerCase().includes(filterValue)
      || cli.id === null ? true : cli.id.toString().includes(filterValue));

      return arr;
    } else {
      return this.clients;
    }
  }

}
